exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/views/pages/transaction/op/outbound/ticket/ticket-entry/ticket-entry.component.css
// module id = 793
// module chunks = 7